import {BaseUtilsService} from "../domain-services/base-utils-service";

export class BaseManager extends BaseUtilsService {
  static injectables = [...BaseUtilsService.injectables];
}
